import * as React from 'react';
import { Container, Row, Col } from 'reactstrap';

namespace AppLayout {
  export interface Props {
    children: any;
  }
  export interface State {
    isNavOpen: boolean;
  }
}

injectStyles();

export class AppLayout extends React.Component<AppLayout.Props, AppLayout.State> {
  render() {
    return (
      <Container fluid={true}>
        <Row className="d-flex">
          <Col className="col-12 px-0 bg-gray-100 vhmh-100">
            {this.props.children}
          </Col>
        </Row>
      </Container>
    );
  }
}

function injectStyles() {
  const style = document.createElement('style');
  style.innerHTML = `
    .vhmh-100 {
      /* used to set body height to viewport minus header */
      min-height: calc(100vh - 75px) !important;
    }
  `;
  document.body.appendChild(style);
}



// WEBPACK FOOTER //
// ./src/portal-react-app/AppLayout.tsx